import { motion } from "framer-motion";
import { Waves, HeartPulse, LineChart, Users, PlayCircle, Timer } from "lucide-react";

const cards = [
  {
    icon: Waves,
    title: "100+ exercises with video",
    body: "Aqua HIIT, aqua yoga, deep-water running and rehab moves — each with step-by-step video.",
    span: "md:col-span-7",
    accent: true,
  },
  {
    icon: HeartPulse,
    title: "Adaptive intensity",
    body: "Every routine scales from gentle recovery to elite conditioning.",
    span: "md:col-span-5",
  },
  {
    icon: LineChart,
    title: "Real-time metrics",
    body: "Stroke rate, laps, calories and recovery, synced from your watch.",
    span: "md:col-span-5",
  },
  {
    icon: Users,
    title: "Built for every body",
    body: "Seniors, athletes, post-injury or first-timers — one app, every level.",
    span: "md:col-span-7",
    accent: true,
  },
  {
    icon: PlayCircle,
    title: "Offline-ready video",
    body: "Download sessions and take them poolside, no signal needed.",
    span: "md:col-span-4",
  },
  {
    icon: Timer,
    title: "5-minute starts",
    body: "Short, focused sets that fit around real life.",
    span: "md:col-span-4",
  },
  {
    icon: Waves,
    title: "Streaks & rewards",
    body: "Stay in the water with playful goals and milestones.",
    span: "md:col-span-4",
  },
];

export const Features = () => {
  return (
    <section id="features" data-testid="features" className="border-t border-textMuted/15 bg-surface/30">
      <div className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40">
        <div className="mb-16 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-xl">
            <p className="mb-4 text-xs font-600 uppercase tracking-[0.3em] text-aqua">Inside the app</p>
            <h2 className="font-display text-4xl font-800 leading-[0.95] tracking-tight text-textMain md:text-6xl">
              Everything you need, in one pool.
            </h2>
          </div>
          <p className="max-w-sm text-textMuted">
            A complete aqua-fitness studio in your pocket — coached, measured and made for you.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-12">
          {cards.map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.div
                key={i}
                data-testid={`feature-card-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
                className={`group flex flex-col justify-between rounded-2xl border p-8 transition-all duration-300 hover:-translate-y-1 ${c.span} ${
                  c.accent
                    ? "border-aqua/30 bg-aqua/[0.04] hover:border-aqua"
                    : "border-textMuted/20 bg-ink hover:border-aqua/60"
                }`}
              >
                <Icon className="h-8 w-8 text-aqua" strokeWidth={1.5} />
                <div className="mt-16">
                  <h3 className="font-display text-2xl font-700 tracking-tight text-textMain">{c.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-textMuted">{c.body}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
